import React from "react";
import { DynamicDropdown, FileDownloader, StaticDropdown } from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import AllocationTableUI from "../StatusSummary/AllocationTableUI";
import { getPortfolioGroupInstrumentOptions } from "../portfolioGroupInstrumentOptions";
import {
  getPortfoGroupCoveredCallTable,
  getPortfoGroupCoveredCallExcel,
} from "src/Requests/portfolioGroups";
import type {
  IPortfoGroupCoveredCallSearchParams,
  IPortfoGroupCoveredCallTableReport,
} from "src/Interfaces/portfolioGroups";
import { portfolioGroupExchangeTypeOptions } from "src/Utils/exchangeTypeOptions";
import PortfolioFilterMultiSelects from "../PortfolioFilterMultiSelects";

const CoveredCallSummary = () => {
  const [searchParams, setSearchParams] =
    React.useState<IPortfoGroupCoveredCallSearchParams>({
      portfoGroupIds: [],
      accountIds: [],
      instrumentId: null,
      exchangeType: null,
    });

  const filterChangeHandler = (name: string, value: number | string) => {
    setSearchParams((prev) => ({
      ...prev,
      [name]:
        value === "" || value == null
          ? null
          : name === "instrumentId"
            ? String(value)
            : Number(value),
    }));
  };

  const multiSelectFilterChangeHandler = (
    name: "portfoGroupIds" | "accountIds",
    value: string[],
  ) => {
    setSearchParams((prev) => ({ ...prev, [name]: value.map(Number) }));
  };

  return (
    <div className="flex flex-col flex-1 w-full gap-3">
      <div className="flex flex-row justify-between items-end gap-3">
        <div className="flex flex-row justify-start items-end gap-3">
          <PortfolioFilterMultiSelects
            portfoGroupIds={searchParams.portfoGroupIds ?? []}
            accountIds={searchParams.accountIds ?? []}
            onChange={multiSelectFilterChangeHandler}
          />
          <div className="w-[220px]">
            <StaticDropdown
              dropdown={{
                name: "exchangeType",
                placeholder: "بورس",
                extraLabel: true,
              }}
              options={portfolioGroupExchangeTypeOptions}
              onChange={filterChangeHandler}
              value={searchParams.exchangeType?.toString() ?? ""}
            />
          </div>
          <div className="w-[220px]">
            <DynamicDropdown
              dropdown={{
                name: "instrumentId",
                placeholder: "نماد پایه یا آپشن",
                extraLabel: true,
              }}
              getData={getPortfolioGroupInstrumentOptions}
              onChange={filterChangeHandler}
              value={searchParams.instrumentId ?? ""}
            />
          </div>
          <div className="w-36">
            <FileDownloader getFile={() => getPortfoGroupCoveredCallExcel(searchParams)} />
          </div>
        </div>
      </div>
      <TableTemplate<
        IPortfoGroupCoveredCallSearchParams,
        IPortfoGroupCoveredCallTableReport
      >
        getDataTable={getPortfoGroupCoveredCallTable}
        searchParameters={searchParams}
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <AllocationTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            autoSizeAccountColumns
            tableBoxClassName="max-h-[800px] portfolio-group-first-row"
          />
        )}
        refreshTableTime={30000}
        pagesize={200}
        withSort
        tableWrapperClassname="!mx-0 flex justify-center"
      />
    </div>
  );
};

export default CoveredCallSummary;
